var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "absolute z-10 left-0 top-header-main-desktop mobile+tablet:hidden w-full h-screen transform"
      ]
    },
    [
      _c("div", {
        class: ["z--1 absolute inset-0 bg-grey-800 opacity-70 cursor-pointer"],
        on: {
          click: function($event) {
            return _vm.closeDesktopMegamenu(true)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["absolute z-10 top-0 left-0 bg-white pt-4 pb-22.5 w-full"],
          on: {
            mouseover: function($event) {
              return _vm.openDesktopMegamenu(_vm.navItem.id)
            },
            mouseleave: function($event) {
              return _vm.closeDesktopMegamenu(false)
            }
          }
        },
        [
          _c("div", { staticClass: "o-wrapper" }, [
            _vm.navItem.heading
              ? _c("div", {
                  class: [
                    "text-md leading-base content mb-4 text-heading font-bold"
                  ],
                  domProps: { innerHTML: _vm._s(_vm.navItem.heading) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-start" },
              _vm._l(_vm.navItem.children, function(
                navChildItem,
                navChildItemIndex
              ) {
                return _c(
                  "div",
                  {
                    key: navChildItem.id,
                    class: [
                      "lg:w-[232px]",
                      navChildItemIndex === 0 ? "" : "lg:ml-7"
                    ]
                  },
                  [
                    navChildItem.transformedImages !== null ||
                    navChildItem.svgImage !== null
                      ? _c("div", { staticClass: "mb-3.5 w-4/5" }, [
                          _c("div", { staticClass: "aspect-w-4 aspect-h-3" }, [
                            navChildItem.transformedImages !== null
                              ? _c("picture", [
                                  _c("source", {
                                    attrs: {
                                      "data-srcset":
                                        navChildItem.transformedImages[0].url,
                                      type: "image/webp"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      "data-srcset":
                                        navChildItem.transformedImages[1].url,
                                      type: "image/jpeg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass:
                                      "w-full h-full object-center object-cover",
                                    attrs: {
                                      src:
                                        navChildItem.transformedImages[1].url,
                                      alt:
                                        navChildItem.transformedImages[1].title
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            navChildItem.svgImage !== null
                              ? _c("img", {
                                  directives: [
                                    { name: "lazy", rawName: "v-lazy" }
                                  ],
                                  staticClass:
                                    "w-full h-full object-cover object-center",
                                  attrs: {
                                    src: navChildItem.svgImage.url,
                                    alt: navChildItem.svgImage.title
                                  }
                                })
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "text-none list-none" },
                      [
                        _c("li", { staticClass: "mb-3.5" }, [
                          _c(
                            "a",
                            {
                              class: [
                                "group relative focus:outline-none text-heading",
                                navChildItem.headerNavType
                                  ? "inline-flex flex-nowrap font-semibold items-center u-body-md rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid border-primary hover:shadow-button-secondary transition duration-200 ease-in-out"
                                  : "inline-block font-bold  u-body-lg",
                                navChildItem.classes,
                                {
                                  "cursor-default": !navChildItem.url
                                }
                              ],
                              attrs: {
                                href: navChildItem.url,
                                target: navChildItem.newWindow
                                  ? "_blank"
                                  : "_self"
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.openDesktopMegamenu(_vm.navItem.id)
                                },
                                blur: function($event) {
                                  return _vm.closeDesktopMegamenu(false)
                                }
                              }
                            },
                            [
                              _c("span", {
                                class: [
                                  "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                ]
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class: [
                                    "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(navChildItem.title) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        navChildItem.children
                          ? _vm._l(navChildItem.children, function(
                              navSubchildItem,
                              navSubchildItemIndex
                            ) {
                              return _c(
                                "li",
                                {
                                  key: navSubchildItem.id,
                                  class:
                                    navSubchildItemIndex === 0 ? "" : "mt-2"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: [
                                        "group relative focus:outline-none ",
                                        navSubchildItem.headerNavType
                                          ? "inline-flex flex-nowrap text-heading font-semibold items-center u-body-md rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid border-primary hover:shadow-button-secondary transition duration-200 ease-in-out"
                                          : "inline-block text-body u-body-lg",
                                        navSubchildItem.classes,
                                        {
                                          "cursor-default": !navSubchildItem.url
                                        }
                                      ],
                                      attrs: {
                                        href: navSubchildItem.url,
                                        target: navSubchildItem.newWindow
                                          ? "_blank"
                                          : "_self"
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.openDesktopMegamenu(
                                            _vm.navItem.id
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.closeDesktopMegamenu(false)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        class: [
                                          "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                        ]
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(navSubchildItem.title) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }